import createPage from "@src/components/page"
import React from "react"
import { animated } from "@react-spring/web"
import * as styles from "./pageBooom.module.scss"
import { useEnteringTrail } from "@src/components/page/lib"
import frameImg from "@images/png/22.png"
import booomJson from "@images/lottieJson/booom.json"
import LottieControl from "@src/components/lottie"
import { imageCdnUrl } from "@src/utils/request"

const PageBooom = createPage(
  ({ data, offset }) => {
    const anime1Styles = useEnteringTrail(3, offset)
    const anime2Styles = useEnteringTrail(1, offset, { step: 0.7 })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.9 })
    const {
      gameData: {
        game: { title, cover },
        members,
        team,
      },
    } = data
    return (
      <>
        <animated.div style={anime1Styles[0]} className={styles.gameContainer}>
          <div className={styles.game}>
            <img src={imageCdnUrl(cover, { w: 576, h: 576 })} alt={title} />
            <img src={frameImg} alt="" />
            <LottieControl
              className={styles.lottie}
              animationData={booomJson}
              config={{ renderer: "svg" }}
              style={anime2Styles[0]}
            />
          </div>
          <div>{title.replace("【BOOOM】", "")}</div>
        </animated.div>
        <animated.div style={anime1Styles[1]} className="line3">
          你加入了<strong>{team}</strong>
          <br />
          并发布了第一款游戏
        </animated.div>
        {members.length > 0 && (
          <animated.div style={anime1Styles[2]} className="line2">
            一同开发的伙伴还有
            <br />
            <strong>{members.join("、")}</strong>
          </animated.div>
        )}
        <animated.div className="bottomText" style={anime3Styles[0]}>
          2021年BOOOM游戏创作挑战活动
          <br />
          共453人参加并创作出73款游戏
        </animated.div>
      </>
    )
  },
  {
    className: styles.page,
  }
)

export const pageBooomData = {
  key: "booom",
  bg: "#FFFF06",
  Page: PageBooom,
  shouldHide: ({ gameData }) => !gameData,
}

PageBooom.displayName = "PageBooom"
export default PageBooom
